export default __webpack_public_path__ + "static/media/ff-webstore.f2d48dfe.png";